<template>
  <div>
    <div class="mb-2">
      <i class="mr-2 fas fa-file mb-1 text-orange" />
      <label class="font-16 color-black font-weight-bold">
        Determinación
      </label>
    </div>
    <div class="mb-2">
      <div class="font-16 color-black">
        Categoría:
      </div>
      <div class="font-14 color-gray-6">
        {{ item.determinationCategory?.name | empty }}
      </div>
    </div>
    <div class="mt-3">
      <i class="mr-2 fas fa-file mb-1 text-orange" />
      <label class="font-16 color-black font-weight-bold">
        Documentos
      </label>
    </div>
    <custom-result-not-found
      v-if="pagination.items.length == 0"
      text="No hay documentos asociados."
    />
    <div v-else>
      <div
        v-for="doc in pagination.items"
        :key="doc.id"
        class="rounded p-3 bg-secondary-3 my-3"
      >
        <div class="row">
          <div class="col-12 col-md">
            <div class="data-name">Archivo:</div>
            <div>{{ doc.name | empty }}</div>
          </div>
          <div class="col-12 col-md">
            <div class="d-flex justify-content-end mt-1">
              <action-button
                i="fas fa-file-download icon-mr-0"
                variant="success"
                @click="download(doc)"
              />
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        show-text
        @pagination-go-page="search"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        i="fas fa-times-circle"
        text="Cerrar"
        variant="outline-danger mr-2"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
import Pagination from 'pagination';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';

import generalApi from '@/modules/app/api';
import { getDeterminationDocuments } from '@/modules/purchaseService/api.js';

export default {
  name: 'Determination',
  components: {
    Pagination,
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: 3,
        items: [],
      },
    };
  },
  async mounted() {
    await this.search();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    download({ id }) {
      generalApi.downloadDocumentByAttachmentId(id);
    },
    async search(pageIndex = 1) {
      const { data: response } = await getDeterminationDocuments(this.item.id, {
        pageIndex,
        pageSize: this.pagination.pageSize,
      });

      this.pagination = {
        ...this.pagination,
        totalItemCount: response.totalItemCount,
        pageCount: response.pageCount,
        currentPage: response.currentPage,
        count: response.count,
        items: response.data,
      };
    },
  },
};
</script>
<style scoped>
::v-deep .icon-mr-0 {
  margin-right: 0 !important;
}
</style>
